import { RootState } from 'store/store';

export const selectAddPropertyExitModalIsVisible = (state: RootState) => state.AddProperty.exitModalIsVisible;
export const selectAddPropertyWorkspace = (state: RootState) => state.AddProperty.workspace;
export const selectAddPropertyUser = (state: RootState) => state.AddProperty.user;
